<template>
  <el-dialog :visible="visible" title="批量搜索" @close="handleCancel">
    <div class="batch-search-dialog">
      <el-input type="textarea" placeholder="请输入内容" v-model="keyword" @input="changeInput" style="height:200px;" ref="batchInput">
      </el-input>
      <div class="submit-btn">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleOk">搜索</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'batchSearchDialog',
  props:{
    max:{
      type:Number,
      default: 500
    }
  },
  data() {
    return {
      visible: false,
      title: "",
      content: "",
      keyword: "",
      key: ""
    }
  },
  methods: {
    open(obj) {
      this.title = obj.title;
      this.content = obj.content;
      this.key = obj.key;
      this.keyword = (obj.data && obj.data.join("\n")) || "";
      this.visible = !this.visible;
      setTimeout(_ => {
        this.$refs['batchInput'].focus()
      }, 100)
    },
    changeInput() {
      this.keyword = this.keyword
        .split(/\n/)
        .splice(0, this.max)
        .join("\n");
    },
    focusIpt(){
      this.$refs['batchInput'].focus()
    },
    handleOk() {
      if (!this.keyword) {
        this.$message.warning("请输入！");
        return
      }
      let obj = {};
      obj[this.key] = this.keyword.trim().split(/\n/).join(',');
      this.$emit("search", obj);
      this.handleCancel();
    },
    handleCancel() {
      this.visible = false;
      this.$emit('batchClose')
    }
  }
}
</script>
<style lang="less" >
.batch-search-dialog {
  .el-textarea__inner {
    height: 200px;

  }
  .submit-btn{
    padding-top:20px;
    text-align: right;
  }
}
</style>
